export default "__VITE_ASSET__BGHPoJfJ__"